export const PopupOpenType = {
  OPEN: 'OPEN',
  HIDDEN: 'HIDDEN',
} as const;

export type PopupOpenType = keyof typeof PopupOpenType;
